import PropTypes from 'prop-types';
import { TEXT_BASE_CLASS } from '../Text/Text.constants';

function TextInput({
  type,
  placeholder,
  value,
  isFocus,
  name,
  onChange,
  onFocus,
  onBlur,
  required,
  tabIndex,
}) {
  return (
    <div
      className={`aaco-input aaco-text-input floating-label ${
        isFocus ? 'aaco-input--is-focus' : ''
      } `}
    >
      <input
        type={type}
        placeholder=" "
        value={value}
        onChange={onChange}
        id={name}
        onFocus={onFocus}
        onBlur={onBlur}
        className={`w-full outline-none ${TEXT_BASE_CLASS['body']} normal-case text-black dd-kr:text-white dd-en:text-white peer bg-transparent`}
        required={required}
        tabIndex={tabIndex}
        {...(type === 'email' && {pattern:"[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}"})}
      />
      <label htmlFor={name} className="peer-placeholder-shown:translate-y-0 cursor-text">
        {placeholder}
      </label>
    </div>
  );
}

TextInput.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  isFocus: PropTypes.bool,
  required: PropTypes.bool,
  tabIndex: PropTypes.number,
};

TextInput.defaultProps = {
  type: 'text',
  placeholder: '',
  name: '',
  isFocus: false,
  required: false,
};

export default TextInput;
